import React from 'react';
import ContactPill from './ContactPill';
import styles from './Contacts.module.scss';

const ContactPills = ({
  data,
  rowId,
  address,
  expandedRowId,
  onExpand,
  limit = 3,
  onRemoveList,
}) => {
  if (!data || data.length === 0) {
    return null; // Or render a placeholder like '-'
  }

  const isExpanded = rowId === expandedRowId;
  const canBeExpanded = data.length > limit;

  const handleExpandClick = () => {
    // If it's already expanded, clicking it again will collapse it.
    // Otherwise, it will expand this row.
    onExpand(isExpanded ? null : rowId);
  };

  const pillsToShow = isExpanded ? data : data.slice(0, limit);

  return (
    <div className={styles.pills_wrapper}>
      {pillsToShow.map((elem) => (
        <ContactPill
          key={`${elem.id}_${elem.type}`}
          data={elem}
          contactId={rowId}
          address={address}
          onRemove={onRemoveList}
        />
      ))}

      {canBeExpanded && !isExpanded && (
        <button
          type="button"
          className={styles.showMoreButton}
          onClick={handleExpandClick}
        >
          + {data.length - limit}
        </button>
      )}
    </div>
  );
};

export default ContactPills;
